import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-barrel-archive',
  templateUrl: './barrel-archive.component.html',
  styleUrls: ['./barrel-archive.component.scss']
})
export class BarrelArchiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
